export default __webpack_public_path__ + "images/54634fce8a24da4268bd794357e2d9de.png";